export const Reports = ({ className }: { className?: string }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m25.7 5h-18.4c-.61 0-1.19501.25058-1.62635.69661-.43133.44603-.67365 1.05098-.67365 1.68177v14.27022c0 .6308.24232 1.2358.67365 1.6818.43134.446 1.01635.6966 1.62635.6966h8.832c-.1265-.5946-.207-1.1892-.207-1.7838 0-2.05.7875-4.0161 2.1894-5.4657 1.4018-1.4496 3.3031-2.264 5.2856-2.264 1.725 0 3.335.6303 4.6 1.6649v-8.80002c0-1.32-1.0235-2.37838-2.3-2.37838zm0 8.3243h-18.4v-3.56755h18.4zm.9545 5.5535 1.3455-1.3913v4.7567h-4.6l2.0355-2.1048c-.4142-.4285-.9451-.7159-1.5216-.8237s-1.1711-.0309-1.7042.2204-.9793.665-1.2787 1.1857-.4378 1.1237-.3967 1.728.2598 1.1813.6267 1.6535c.367.4723.8647.8174 1.4266.989.5619.1717 1.161.1618 1.7173-.0285.5562-.1902 1.043-.5516 1.3951-1.0358h1.9665c-.3426.8796-.9321 1.6329-1.6925 2.1628-.7605.5299-1.657.8121-2.574.8102-2.5415 0-4.6-2.1287-4.6-4.7568s2.0585-4.7567 4.6-4.7567c1.2765 0 2.4265.5351 3.2545 1.3913z"
        fill="currentColor"
      />
    </svg>
  );
};
